var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.1 58.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.1,56H54V24h8v30h2V22H52V56H44.06l-.06-24H32L32,56H24V39.43H12V56H2.06L2,1A1,1,0,0,0,0,1V58H77.1a1,1,0,0,0,0-2ZM22,56H14.06L14,41.43h8Zm20,0H34v-22h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.84,2.27l-.61,1.91,5.31,1.69L11.4,32.32A1,1,0,0,0,11,33.67a1,1,0,0,0,1.35.43L63.46,7.64,61.77,13l1.91.61L66.41,5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIco);
export default __webpack_public_path__ + "static/media/chart-ico.e573631c2f1f6cfac966d90f7ca1cdb8.svg";
export { ForwardRef as ReactComponent };